import React from 'react';

const DownChevronIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#3FB0E8">
        <path d="M12 3.729L10.825 2.5 6 7.551 1.175 2.5 0 3.729 6 10z" />
      </g>
    </g>
  </svg>
);

export default DownChevronIcon;
